import { useParams, useSearchParams } from 'react-router-dom';

import useLinkAfterCreate from 'src/Components/EntityLinks/hooks/useLinkAfterCreate';
import { TaskForm } from 'src/Components/Forms/Task/TaskForm';
import { useCreateTaskForm } from 'src/Hooks/Forms/useCreateTaskForm';
import useCreateTask from 'src/Hooks/Mutations/useCreateTask';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';
import { CreateTaskDto } from 'src/types/task.types';

import { Props } from './TaskCreationFormWrapper.types';

const TaskCreationFormWrapper = ({ onClose }: Props) => {
  const { assetId } = useParams<{ assetId: string }>();
  const [searchParams] = useSearchParams();
  const { mutate: createTask, isLoading } = useCreateTask(assetId!);
  const { handleCreated } = useLinkAfterCreate(LinkableEntityType.Task);

  const communityFeedItemId = searchParams.get('communityFeedItemId');
  const projectId = searchParams.get('projectId');

  const { form } = useCreateTaskForm({
    initialCommunityFeedItemId: communityFeedItemId,
    initialProjectId: projectId,
  });

  const handleSubmit = (values: CreateTaskDto) => {
    createTask(values, {
      onSuccess: data => handleCreated(data.id, onClose),
    });
  };

  return (
    <TaskForm
      form={form}
      onSubmit={form.onSubmit(handleSubmit)}
      onCancel={onClose}
      isLoading={isLoading}
    />
  );
};

export default TaskCreationFormWrapper;
